import { render } from "./ChatGroupMembers.vue?vue&type=template&id=f8198de4&scoped=true"
import script from "./ChatGroupMembers.vue?vue&type=script&lang=js"
export * from "./ChatGroupMembers.vue?vue&type=script&lang=js"

import "./ChatGroupMembers.vue?vue&type=style&index=0&id=f8198de4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8198de4"]])

export default __exports__